import React from 'react';
import { Container } from '../layout';
import Loader from './Loader';

const ContainerLoader = () => (
  <Container>
    <Loader />
  </Container>
);

ContainerLoader.propTypes = {};

ContainerLoader.defaultProps = {};

export default React.memo(ContainerLoader);
